import React from 'react';
import { ChevronDown } from 'lucide-react';

interface ModelOption {
  l: string;
  v: string;
}

interface ModelConfigEditorProps {
  nodeId: string;
  model?: string;
  models: ModelOption[];
  onUpdate: (id: string, data: any) => void;
  layout?: 'horizontal' | 'vertical';
}

export const ModelConfigEditor: React.FC<ModelConfigEditorProps> = ({
  nodeId,
  model,
  models,
  onUpdate,
  layout = 'horizontal',
}) => {
  if (layout === 'vertical') {
    return (
      <div className="flex items-center justify-between gap-4">
        <span className="text-[12px] text-white w-12 shrink-0">模型选择</span>
        <div className="relative group/upscale-model" style={{ width: '300px' }}>
          <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white/[0.06] border border-white/[0.10] cursor-pointer transition-colors text-[12px] font-medium text-white hover:bg-white/10">
            <span className="flex-1">{models.find(m => m.v === model)?.l || 'TopazLabs'}</span>
            <ChevronDown size={12} className="text-white/40" />
          </div>
          <div className="absolute top-full right-0 pt-2 w-full opacity-0 -translate-y-2 pointer-events-none group-hover/upscale-model:opacity-100 group-hover/upscale-model:translate-y-0 group-hover/upscale-model:pointer-events-auto transition-all duration-200 z-[200]">
            <div className="bg-[#1c1c1e] border border-white/10 rounded-xl shadow-xl overflow-hidden">
              {models.map(m => (
                <div
                  key={m.v}
                  onClick={() => onUpdate(nodeId, { model: m.v })}
                  className={`px-3 py-2 text-xs font-medium cursor-pointer hover:bg-white/10 ${model === m.v ? 'text-white bg-white/5' : 'text-white/60'}`}
                >
                  {m.l}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative group/model">
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg hover:bg-white/5 cursor-default transition-colors text-xs font-medium text-white/60 hover:text-white">
        <span>{models.find(m => m.v === model)?.l || 'AI Model'}</span>
        <ChevronDown size={12} />
      </div>
      <div className="absolute bottom-full left-0 pb-2 w-40 opacity-0 translate-y-2 pointer-events-none group-hover/model:opacity-100 group-hover/model:translate-y-0 group-hover/model:pointer-events-auto transition-all duration-200 z-[200]">
        <div className="bg-[#1c1c1e] border border-white/10 rounded-xl shadow-xl overflow-hidden">
          {models.map(m => (
            <div
              key={m.v}
              onClick={() => onUpdate(nodeId, { model: m.v })}
              className={`px-3 py-2 text-xs font-medium cursor-pointer hover:bg-white/10 ${model === m.v ? 'text-white bg-white/5' : 'text-white/60'}`}
            >
              {m.l}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
